import { Component, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { DataService, Loading } from 'src/app/Services/Data/data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DatabindingService } from 'src/app/Services/Databinding/databinding.service';
import { APP_BASE_LINK } from 'src/environments/constants';

let documentsModel: any = {
  folders: [
    {
      name: 'Document',
      documents: []
    }
  ]
};

@Component({
  selector: 'options-table',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.css']
})
export class OptionsComponent implements OnInit {
  @Output() documentSelected: EventEmitter<any>;
  folders: any = [];
  title = 'templates';
  type = '';
  state = 'inactive';
  selected_document: any;
  new_document: any;
  selected_document_name = '';
  // user login
  login = false;
  user_data: any;
  // Loading
  loading: Loading;
  // error
  error_messages: any = [];
  // Popups
  document_popup = false;
  group_popup = false;
  is_show_pushback_popup = false;
  edit_document = false;
  edit_annotations = false;

  edit_document_url: any;
  annotations_url: any;

  // pushback
  selected_pushback_document: any;
  is_user_owner_of_selected_document = true;
  pushbackType: any = { name: '' }; // it can be changed by reference in databinding-form
  display_pushback: boolean;

  // template_settings
  template_setting: any;
  template_setting_id: string;
  using_template_settings: boolean;
  loading_template_setting: boolean;

  // Data
  data: any = [];
  salesforce: any = [];
  document_group: any = [];

  // pre-selected template
  selected_template_id: string;

  // email dropdown
  emails: any = [];

  // refresh the page
  refresh: boolean;

  type_placeholder = 'SALESFORCE_RECORD_TYPE';

  // Salesforce-session-data
  salesforce_session_data: any;
  //loadedSalesforceSessionData
  isSFDataLoaded: boolean = false;

  sfObjectsList = [];
  sfCurrObjMetaList = [];
  pushBackErrorsMsg = {
    cannotAddPushbackToRecord: `Cannot save Data Binding without a specified 'Salesforce Record Type'. Please update Data Binding.`,
    cannotAssignPushbackRecord: `Cannot save Data Binding without at least one specified 'Salesforce Field Name'. Please update Data Binding.`,
    duplicatePushbackField:
      'Duplicate field values detected for Salesforce Data Binding. Please ensure all field values for updating a record are unique.',
    duplicatePushbackTypes:
      'Duplicate Salesforce Type values. Please make sure that there is only one Type value for Data Binding.'
  };

  appendingDataErrorMsg = {
    general_error: 'Error prefilling data into signnow fields from salesforce.'
  };

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private dataService: DataService,
    private renderer: Renderer2,
    private databindingService: DatabindingService
  ) {
    this.loading = dataService.getLoading();
    this.documentSelected = new EventEmitter();
    renderer.listen('window', 'message', this.handleMessage.bind(this));
  }

  ngOnInit() {
    this.getSalesforceSessionDataApiJSONFormat().subscribe((result) => {
      this.refresh = false;
      this.setSalesforceSessionDataGlobalObject(result);
      this.loadSalesforceDataIntoDataService();
      this.checkData();
    });
  }

  searchDocuments(value, tableId: string) {
    const filter = value.toUpperCase();
    const tr = this.LoadTableColumnsGivenTableId(tableId);
    this.LoopThroughtTheTableAndFilterFirstTwoColumns(tr, filter);
  }

  setupFolders() {
    this.folders = documentsModel.folders;
  }

  handleMessage(event: Event) {
    const message = event as MessageEvent;
    if (message.data === 'close_popup') {
      this.edit_document = false;
      this.edit_document_url = '';
      this.reload_view();
    }
  }

  loadInfo() {
    this.data = this.dataService.getData();
    this.salesforce = this.dataService.getSalesforceData();
    this.document_group = this.dataService.getDocumentGroup();
  }

  reload_view() {
    this.clearErrors();
    this.refresh = false;
    this.updateLoading(false, '');
    this.folders = [];
    this.dataService.resetData();
    this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
    this.hideAllModals();
  }

  validValue(value): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    return true;
  }

  async checkData() {
    try {
      await this.processCheckData();
    } catch (error) {
      return error;
    }
  }

  setOriginView(view: string, page_view: string) {
    if (page_view == undefined) {
      this.dataService.setOriginView(view);
    } else {
      this.dataService.setOriginView(page_view);
    }
  }

  DataIsValid() {
    const template_setting_id = this.dataService.getUrlParamater('template_setting');

    if (template_setting_id != '' && template_setting_id.length > 0) {
      this.using_template_settings = true;
      this.loading_template_setting = true;
      this.loadTemplateSettingAndPages(template_setting_id);
    } else {
      this.using_template_settings = false;
    }
  }

  async generateUserDataObject() {
    await this.getSalesforceSessionDataFromBackend();
    if (this.checkIfSessionIsNotValid()) {
      this.invalidSalesforceSessionDisplayLoginAndError();
    } else {
      return this.initializeUserDataFromSalesforceSessionGlobalData();
    }
  }

  loadTemplateSetting(template_setting_id) {
    this.updateLoading(true, 'Loading template settings data.');
    this.loadInfo();
    const data = this.configureGetTemplateSettingsApiDataParameter(template_setting_id);
    this.executeLoadTemplateSettings(data);
  }

  loadTemplateSettingAndPages(template_setting_id) {
    this.updateLoading(true, 'Loading template settings data.');
    this.loadInfo();
    this.executeLoadTemplateSettingsAndPages(template_setting_id);
  }

  removeErrorMessage(error_message) {
    for (let i = 0; i < this.error_messages.length; i++) {
      if (error_message == this.error_messages[i]) {
        // delete this.error_messages[i];
        this.error_messages.splice(i, 1);
      }
    }
  }

  async loadSalesforceDataIntoDataService() {
    if (this.isSFDataLoaded === false) {
      this.isSFDataLoaded = true;
      await this.getSalesforceSessionDataFromBackend();
    }

    if (this.checkIfSessionIsNotValid()) {
      this.forceUsersToLoginBeforeContinuing();
    }
  }

  getRecordEmails(record_type, instance_url, sf_token) {
    try {
      this.executeGetRecordEmails(sf_token, instance_url, record_type);
    } catch {}
  }

  async loadSalesforceDataFromParentFrameAndUpdateUserDB() {
    try {
      await this.processLoadSalesforceDataFromParentFrameAndUpdateUserDB();
    } catch {}
  }

  logoutUser() {
    this.updateLoading(true, 'logging out user!');
    this.user_data.sn_token = '';
    this.user_data.sn_refresh = '';
    this.user_data.sn_email = '';
    this.userDBApi().subscribe(() => {
      this.forceUsersToLoginBeforeContinuing();
    });
  }

  private userDBApi() {
    return this.dataService.apiPostCall('/api/update_user_db', JSON.stringify(this.user_data));
  }

  async salesforce_data_is_good() {
    const salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(salesforce_session_data);

    if (!this.dataService.valid_salesforce_session(salesforce_session_data)) {
      this.updateLoading(false, '');
      this.updateError(this.dataService.salesforce_session_error);
      return false;
    }
    return true;
  }

  loginUser(email, password) {
    const login_data = {
      username: email,
      password: password
    };
    this.updateLoading(true, 'Requesting to login with SignNow.');
    this.loginToSignNow(login_data).subscribe((result) => {
      this.processLoginToSignNowResult(result, email);
    });
  }

  reload() {
    this.folders = [];
    this.loadSalesforceDataIntoDataService();
    this.updateLoading(true, '');
    this.checkData();
  }

  hideAllModals() {
    this.document_popup = false;
    this.group_popup = false;
    this.is_show_pushback_popup = false;
  }

  toggleMove() {
    this.state = this.state === 'inactive' ? 'active' : 'inactive';
  }

  documentNamePopup(document: any) {
    this.showDocumentPopupHideGroupPopup();
    this.AssignDocumentToGlobalParameterSelectedDocument(document);
    if (this.isUsingTemplateSettings()) {
      this.documentPopupWithTemplateSettings(document);
    } else {
      this.setGlobalSelectedDocumentName(document.document_name);
    }
  }

  async AppendSFDataToPrefillSNFieldsInDocumentGroup(document_ids) {
    const succesfullyAppendSFDataToFieldCount = await this.appendSFDataToSNFieldsInDocuments(document_ids);
    return this.isSuccessCountEqualsDocumentIdsCount(succesfullyAppendSFDataToFieldCount, document_ids);
  }

  addAnnotationsToDocument(new_document) {
    const data = this.dataService.getData();
    const salesforceAnnotationData = this.initSalesforceAnnotationDataForApiParameter(data);
    const message = 'Adding annotations data from salesforce to the document.';
    this.updateLoading(true, message);
    this.executeAddAnnotationsToDocument(data, salesforceAnnotationData, new_document);
  }

  clearErrors() {
    this.error_messages = [];
  }

  updateLoadingEvent($event) {
    this.updateLoading($event.state, $event.msg);
  }
  updateLoading(state: boolean, msg: string) {
    this.loading.update(state, msg);
  }

  preselectedTemplate(selectedTemplateId) {
    this.updateLoading(true, 'Loading preselected template.');
    this.getDocumentApi(selectedTemplateId).subscribe((template) => {
      this.displayDocumentPopup(template);
    });
  }

  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }

  addPushbackDataToDocument() {
    this.clearErrorsAndSetLoadingMessage('Adding pushback data to the template.');
    let { field_value_counts, field_value_counts_update, fields } = this.initAddDataBindingVariables();
    const { valid_field_count, document } = this.processFieldsValuesForDatabinding(
      field_value_counts,
      field_value_counts_update,
      this.selected_pushback_document
    );
    this.setSelectedDocumentToCurrentDocument(document);
    this.resetDatabindingErrors();
    this.checkPushbackErrors(valid_field_count, field_value_counts_update);
    fields = this.configurePushBackFields(fields);
    this.addPushbackToTemplateApi(this.selected_pushback_document.id, fields).subscribe(
      this.processPushbackToTemplateApiResponse()
    );
  }

  // todo move to Databinding Service
  // for analytics purpose
  // only when updating the document that will be sent to Send Page
  setDatabindingInfoForAnalytics(fields) {
    const databindingInfoForAnalytics = {
      is_update: fields.some((field) => field.integrations[0].update === 'yes'),
      is_append: fields.some((field) => field.integrations[0].isAppendToSN === 'yes')
    };
    this.dataService.addAnalyticsDatabindingInfo(databindingInfoForAnalytics);
  }

  prepDocumentForDatabinding(document) {
    this.ResetDuplicatePushbackTypeErrorMessages();
    const dataBindingTypes: Set<string> = new Set<string>();
    this.loopOverFieldsInDocumentAndSetupDatabinding(document, dataBindingTypes);
    const dataBindingTypesArray = this.ConvertDataBindingTypesToArray(dataBindingTypes);
    this.ifDatabindingTypesArrayLengthIsntEmptyErrorDuplicateTypes(dataBindingTypesArray);
    this.ifDataBindingTypesArrayLengthIsOneSetPushbackType(dataBindingTypesArray);
    return document;
  }

  async AppendSFDataToPrefillSNFields(initDocument) {
    this.clearErrorsAndSetLoadingMessage('Adding Salesforce Fields to the Document.');
    let document = this.prepDocumentForDatabinding(initDocument);
    const { field_value_counts, field_value_counts_update, fields } = this.initAddDataBindingVariables();
    ({ document } = this.processFieldsValuesForDatabinding(
      field_value_counts,
      field_value_counts_update,
      document
    ));
    this.resetDatabindingErrors();
    return await this.processAppendSFDataToPrefillSNFields(document, fields);
  }

  selectedDocumentSettingsNew(selectedOption, document) {
    this.setSelectedDocumentToCurrentDocument(document);
    this.clearErrors();
    this.ifRefreshRequiredIsTrueAndSelectedOptionIsPushbackErrorReload(selectedOption);
    const countNumAppropriateFieldsInDoc = 0;
    this.setRefreshState(false);
    this.executBasedOnSelectedOption(selectedOption, document, countNumAppropriateFieldsInDoc);
  }

  selectedDocumentSettings(selected_option, document) {
    this.clearErrors();
    if (this.refresh == true && selected_option.value == 'pushback') {
      selected_option.selectedIndex = 0;
      this.updateError('Please click Reload before setting Data Binding for the document.');
      return;
    }

    let count_num_appropriate_fields_in_doc = 0;
    this.refresh = false;
    if (selected_option.value == 'edit') {
      const redirect_url = window.location.origin + '/close_popup';
      this.edit_document = true;

      const sn_token = this.user_data.sn_token;
      const url = `${APP_BASE_LINK}/webapp/document/${document.id}?access_token=${sn_token}&redirect_uri=`;
      this.edit_document_url = this.sanitizer.bypassSecurityTrustResourceUrl(
        url + encodeURIComponent(redirect_url)
      );

      selected_option.selectedIndex = 0;
    } else if (selected_option.value === 'annotations') {
      const url = `${APP_BASE_LINK}/webapp/annotations/${document.id}?annotation_types=salesforce`;
      window.open(url, '_blank');
      selected_option.selectedIndex = 0;
    } else if (selected_option.value === 'pushback') {
      this.is_show_pushback_popup = true;
      for (let i = 0; i < document.fields.length; i++) {
        if (
          document.fields[i].type === 'text' ||
          document.fields[i].type === 'checkbox' ||
          document.fields[i].type === 'radiobutton' ||
          document.fields[i].type === 'enumeration'
        ) {
          count_num_appropriate_fields_in_doc++;
        }
        if (
          document.fields[i].json_attributes.name == null ||
          document.fields[i].json_attributes.name == undefined
        ) {
          document.fields[i].json_attributes.name = '';
        }

        if (
          document.fields[i].json_attributes.label == null ||
          document.fields[i].json_attributes.label == undefined
        ) {
          document.fields[i].json_attributes.label = '';
        }
        let integrations;
        if (
          document.fields[i].json_attributes.integrations == undefined ||
          document.fields[i].json_attributes.integrations == null
        ) {
          integrations = [
            {
              type: '',
              field: '',
              update: 'no',
              isAppendToSN: 'no',
              integration_id: '98e94c607b2be81b9ddec0a8a2388066141b8027'
            }
          ];
        } else {
          integrations = document.fields[i].json_attributes.integrations;
        }
        document.fields[i].integrations = integrations;
      }
      if (count_num_appropriate_fields_in_doc == 0) {
        this.display_pushback = false;
      } else {
        this.display_pushback = true;
      }
      this.pushbackType.name = document.fields.length ? document.fields[0].integrations[0].type : '';
      this.selected_pushback_document = document;
      selected_option.selectedIndex = 0;

      this.is_user_owner_of_selected_document = this.selected_pushback_document.is_owner;
      // this.getSfObjectMeta(this.pushbackType.name);
    }
  }

  cloneTemplate(new_name: any): void {
    this.setLoadingDisplay('Generating a new document copy of the selected SignNow Document.');
    this.HideDocumentPopup();
    this.SetDataServiceParametersBeforeCloningTemplate(new_name);
    this.ifDocumentNameIsBlankHidePopupsErrorAndResetData(new_name);
    const document: any = this.getDocumentFromGlobalSelectedDocument();
    const type = this.getTypeFromDataService();
    const pushback_type = this.setPushBackTypeFromDocumentIntegrationObject(document);
    this.ifPushBackTypeIsNotValidError(pushback_type, type, document);
    this.ifPushBackTypeIsValidErrorContinue(pushback_type, type, document, new_name);
  }

  generateDocumentFromTemplate(document: any): void {
    this.executeGenerateDocumentFromTemplate(document);
    this.documentSelected.emit(document);
  }

  getDocumentsFromFolder(folder_id: string, callback) {
    this.templateInFolderApi(folder_id).subscribe((result) => {
      callback(result);
    });
  }

  async getAllFoldersAndDocuments() {
    const selected_template_id = this.setGlobalSelectedTemplateFromUrl();
    const current_user_sn_email = this.getCurrentSNEmailFromDataService();
    this.ifTemplateSettingIsValidDisplayDocumentPopup(selected_template_id);
    const count = 0;
    const folders: any = [];
    this.setLoadingDisplay('Getting SignNow folders and documents.');
    this.getFoldersAndDocuments(folders, count, current_user_sn_email);
    this.loopOverFoldersIfTeamTemplatesSetTeamNameToName(folders);
    this.setLocalFoldersListToGlobalFoldersList(folders);
  }

  resetDataAndUpdateErrorEvent($event) {
    this.resetDataAndUpdateError(
      $event.errorMsg,
      $event.isHideModal,
      $event.updLoadingState,
      $event.updLoadingMsg
    );
  }
  resetDataAndUpdateError(errorMsg, isHideModal = false, updLoadingState = false, updLoadingMsg = '') {
    this.updateLoading(updLoadingState, updLoadingMsg);
    this.folders = [];
    this.dataService.resetData();
    this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
    if (errorMsg !== false) {
      this.updateError(errorMsg);
    }
    if (isHideModal) {
      this.hideAllModals();
    }
  }

  cancelGenerateGroup(isShowDocGroupTemplates = false) {
    if (isShowDocGroupTemplates) {
      this.clearDocGroup_and_unsetDocGroupTemplate();
    }

    this.hideAllModals();
  }

  clearDocGroup_and_unsetDocGroupTemplate() {
    this.dataService.clearDocumentGroup();
    this.dataService.unsetDocumentGroupTemplateId();
  }

  bindEvent(element, eventName, eventHandler) {
    if (element.addEventListener) {
      element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
      element.attachEvent('on' + eventName, eventHandler);
    }
  }

  stopDisplayLoading() {
    this.updateLoading(false, '');
  }

  errorOccuredWhileGettingFoldersFromApi(error: any) {
    this.errorOccured(error);
  }

  loopOverFoldersIfTeamTemplatesSetTeamNameToName(folders: any) {
    for (let i = 0; i < folders.length; i++) {
      if (folders[i].name === 'Team Templates') {
        folders[i].name = folders[i].team_name;
      }
    }
  }

  setLocalFoldersListToGlobalFoldersList(folders: any) {
    this.folders = folders;
  }

  setTemplateIdFromGivenTemplate(template: any) {
    return template.id;
  }

  getPushBackTypeFromTemplate(template: any) {
    let pushback_type = '';
    try {
      pushback_type = this.setPushBackTypeToTemplateType(template, pushback_type);
    } catch {}
    return pushback_type;
  }

  setPushBackTypeToTemplateType(template: any, pushback_type: string) {
    if (template.fields[0].json_attributes.integrations[0].type) {
      pushback_type = template.fields[0].json_attributes.integrations[0].type;
    }
    return pushback_type;
  }

  getCurrentSFRecordsType() {
    return this.dataService.getSalesforceRecordType();
  }

  checkIfPushBackTypeIsValid(pushback_type: string, type: string, document_name: any) {
    let validType = true;
    if (pushback_type !== '' && pushback_type !== type) {
      const errMsg = `For the template "${document_name}" Data Binding record type is set to "${pushback_type}". Go to Data Binding settings and choose "${type}" record type to send out this template.`;
      this.folders = [];
      this.resetDataAndUpdateError(errMsg);
      validType = false;
    }
    return validType;
  }

  private LoadTableColumnsGivenTableId(tableId: string) {
    const table = document.getElementById(tableId);
    const tr = table.getElementsByTagName('tr');
    return tr;
  }

  private LoopThroughtTheTableAndFilterFirstTwoColumns(tr: any, filter: any) {
    let td, td2;
    for (let i = 0; i < tr.length; i++) {
      td = this.assignTdToFirstColumnDataInTable(td, tr, i);
      this.ApplySearchFilter(td, filter, tr, i);
      td2 = this.assignTd2ToSecondColumnDataInTable(td2, tr, i);
      this.ApplySearchFilter(td2, filter, tr, i);
    }
  }

  private ApplySearchFilter(td: any, filter: any, tr: any, i: number) {
    if (td) {
      this.IfSearchFilterIsFoundDisplayOtherwiseHide(td, filter, tr, i);
    }
  }

  private assignTd2ToSecondColumnDataInTable(td2: any, tr: NodeListOf<HTMLTableRowElement>, i: number) {
    td2 = tr[i].getElementsByTagName('td')[1];
    return td2;
  }

  private IfSearchFilterIsFoundDisplayOtherwiseHide(
    td: any,
    filter: any,
    tr: NodeListOf<HTMLTableRowElement>,
    i: number
  ) {
    if (td.innerText.toUpperCase().indexOf(filter) > -1) {
      tr[i].style.display = '';
    } else {
      tr[i].style.display = 'none';
    }
  }

  private assignTdToFirstColumnDataInTable(td: any, tr: NodeListOf<HTMLTableRowElement>, i: number) {
    td = tr[i].getElementsByTagName('td')[0];
    return td;
  }

  private async processCheckData() {
    await this.getSalesforceSessionDataFromBackend();
    const { record_type, sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url } =
      this.setLocalParametersFromSalesforceSession();
    this.recordTypeGlobalConfigurations(record_type);
    await this.validSessionCheckUserDataOrForceLogin(
      sf_user_id,
      sf_org_id,
      sf_token,
      sf_refresh,
      instance_url
    );
  }

  private async validSessionCheckUserDataOrForceLogin(
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any
  ) {
    if (this.checkIfSessionIsNotValid()) {
      this.invalidSalesforceSessionDisplayLoginAndError();
    } else {
      // send information to db: user will be added if not already found in db otherwise user data will be updated
      await this.checkIfUserDataIsValid(sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url);
    }
  }

  private recordTypeGlobalConfigurations(record_type: any) {
    this.setTypePlaceHolderTextWithRecordType(record_type);
    this.addRecordTypeToSalesforceObjectList(record_type);
  }

  private async checkIfUserDataIsValid(
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any
  ) {
    const result = await this.processCheckUserDataValidInDBAPICall(
      sf_user_id,
      sf_org_id,
      sf_token,
      sf_refresh,
      instance_url
    );
    const { in_db, valid_sn_token } = this.setValidingSNParametersFromCheckUserInDBResult(result);
    if (this.SNUserInDBWithValidCredentials(in_db, valid_sn_token)) {
      this.forceUsersToLoginBeforeContinuing();
    } else {
      this.configureTheValidUserData(result, sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url);

      this.getDocuments();
    }
  }

  private configureTheValidUserData(
    result: any,
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any
  ) {
    const { sn_token, sn_refresh, sn_email } = this.getParametersFromResultForCheckUserDataInDB(result);
    this.setupUserDataGlobalObjectWithValidSNTokenAndRefresh(
      sf_user_id,
      sf_org_id,
      sf_token,
      sf_refresh,
      instance_url,
      sn_token,
      sn_refresh
    );
    this.updateDataServiceWithSNEmail(sn_email);
    this.DataIsValid();
    this.ifUserDataIsValidUpdateUserDB();
  }

  private getParametersFromResultForCheckUserDataInDB(result) {
    const { sn_token, sn_refresh } = this.setSNTokenAndRefreshFromCheckUserInDBResult(result);
    const sn_email = this.getSNEmailFromResult(result);
    return { sn_token, sn_refresh, sn_email };
  }

  private async processCheckUserDataValidInDBAPICall(
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any
  ) {
    this.setupUserDataGobalObject(sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url);
    this.updateLoading(true, "Checking validity of user's token.");

    return this.checkIfUserInDbGivenSalesforceUserIdPromise(sf_user_id);
  }

  private ifUserDataIsValidUpdateUserDB() {
    if (
      this.user_data.sn_token != '' &&
      this.user_data.sf_token != null &&
      this.user_data.sf_token != '' &&
      this.user_data.instance_url != null &&
      this.user_data.instance_url != ''
    ) {
      this.updateUserDBGivenUserData();
    }
  }

  private updateUserDBGivenUserData() {
    return this.userDBApi();
  }

  private updateDataServiceWithSNEmail(sn_email: any) {
    this.dataService.setSignNowOwnerEmail(sn_email);
  }

  private getSNEmailFromResult(result: any) {
    return result.sn_email;
  }

  private setupUserDataGlobalObjectWithValidSNTokenAndRefresh(
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any,
    sn_token: any,
    sn_refresh: any
  ) {
    this.setupUserDataGobalObject(sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url);
    this.user_data.sn_token = sn_token;
    this.user_data.sn_refresh = sn_refresh;
  }

  private setSNTokenAndRefreshFromCheckUserInDBResult(result: any) {
    const sn_token = result.sn_token;
    const sn_refresh = result.sn_refresh;
    return { sn_token, sn_refresh };
  }

  private forceUsersToLoginBeforeContinuing() {
    this.updateLoading(false, '');
    this.folders = [];
    this.login = true;
  }

  private SNUserInDBWithValidCredentials(in_db: any, valid_sn_token: any) {
    return !(in_db === true && valid_sn_token === true);
  }

  private setValidingSNParametersFromCheckUserInDBResult(result: any) {
    const in_db = result.in_db;
    const valid_sn_token = result.valid_sn_token;
    return { in_db, valid_sn_token };
  }

  private checkIfUserInDbGivenSalesforceUserIdPromise(sf_user_id: any) {
    return this.dataService
      .apiGetCall('/api/check_if_user_in_db_with_valid_sn_token?user_id=' + sf_user_id)
      .toPromise();
  }

  private checkIfUserInDbGivenSalesforceUserId(sf_user_id: any) {
    return this.dataService.apiGetCall('/api/check_if_user_in_db_with_valid_sn_token?user_id=' + sf_user_id);
  }

  private addRecordTypeToSalesforceObjectList(record_type: any) {
    this.sfObjectsList.push(record_type);
  }

  private invalidSalesforceSessionDisplayLoginAndError() {
    this.updateLoading(false, '');
    this.updateError(this.dataService.salesforce_session_error);
    this.folders = [];
    this.login = true;
  }

  private checkIfSessionIsNotValid() {
    return !this.dataService.valid_salesforce_session(this.salesforce_session_data);
  }

  private setTypePlaceHolderTextWithRecordType(record_type: any) {
    this.type_placeholder = 'SALESFORCE_RECORD_TYPE (' + record_type + ')';
  }

  private setLocalParametersFromSalesforceSession() {
    const sf_token = this.salesforce_session_data.sf_token;
    const sf_refresh = this.salesforce_session_data.sf_refresh;
    const sf_org_id = this.salesforce_session_data.sf_org_id;
    const sf_user_id = this.salesforce_session_data.sf_user_id;
    const instance_url = this.salesforce_session_data.instance_url;
    const record_type = this.salesforce_session_data.record_type;
    const record_id = this.salesforce_session_data.record_id;
    const context = this.salesforce_session_data.context;
    const view = this.salesforce_session_data.view;
    return {
      record_type,
      sf_user_id,
      sf_org_id,
      sf_token,
      sf_refresh,
      instance_url,
      record_id,
      context,
      view
    };
  }

  private async getSalesforceSessionDataFromBackend() {
    this.salesforce_session_data = await this.getSalesforceSessionDataFromApi().toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);
  }

  private getSalesforceSessionDataFromApi() {
    // console.log('getSalesforceSessionDataFromApi()');
    return this.dataService.apiGetCall('/api/salesforce_session_data');
  }

  private initializeUserDataFromSalesforceSessionGlobalData() {
    const { sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url } =
      this.setLocalParametersFromSalesforceSession();
    const user_data = {
      sf_user_id: sf_user_id,
      sn_token: '',
      sn_refresh: '',
      sf_org_id: sf_org_id,
      sf_token: sf_token,
      sf_refresh: sf_refresh,
      instance_url: instance_url
    };
    return user_data;
  }

  private setSalesforceSessionDataGlobalObject(_salesforce_session_data: any) {
    this.salesforce_session_data = _salesforce_session_data;

    this.dataService.maintenanceCheck(this.salesforce_session_data);
  }

  private getSalesforceSessionDataApiJSONFormat() {
    // console.log('getSalesforceSessionDataApiJSONFormat()');
    return this.dataService.apiGetCall('/api/salesforce_session_data');
  }

  private executeLoadTemplateSettings(data: {
    sf_token: any;
    instance_url: any;
    template_setting_id: any;
    record_id: any;
  }) {
    this.getTemplateSettingsFromApiJSON(data).subscribe(
      (result) => {
        this.processGetTemplateSettingsResult(result);
        this.loadInfo();
        this.updateLoading(false, '');
      },
      (error) => {
        this.processGetTemplateSettingsError(error);
      }
    );
  }

  private processGetTemplateSettingsError(error: any) {
    if (error.status == 504) {
      this.updateError('Failed to load Template Setting.');
    } else {
      this.errorUpdateWithErrorBody(error);
    }
    this.setTemplateSettingsGlobalParametersToFalse();
    this.updateLoading(false, '');
  }

  private setTemplateSettingsGlobalParametersToFalse() {
    this.using_template_settings = false;
    this.loading_template_setting = false;
  }

  private processGetTemplateSettingsResult(result: any) {
    const _template_setting = result;
    this.setTemplateSettingDataServiceAndGlobalParameters(_template_setting);
    this.loading_template_setting = false;
  }

  private setTemplateSettingDataServiceAndGlobalParameters(_template_setting: any) {
    this.setTemplateSettingOnDataService(_template_setting);
    this.setTemplateSettingGlobalParameter(_template_setting);
  }

  private setTemplateSettingGlobalParameter(_template_setting: any) {
    this.template_setting = _template_setting;
  }

  private setTemplateSettingOnDataService(_template_setting: any) {
    this.dataService.setTemplateSetting(_template_setting);
  }

  private configureGetTemplateSettingsApiDataParameter(template_setting_id: any) {
    return {
      sf_token: this.salesforce.sf_token,
      instance_url: this.salesforce.instance_url,
      template_setting_id: template_setting_id,
      record_id: this.salesforce.record_id
    };
  }

  private getTemplateSettingsFromApiJSON(data: {
    sf_token: any;
    instance_url: any;
    template_setting_id: any;
    record_id: any;
  }) {
    return this.dataService.apiPostCall('/api/get_template_setting', data);
  }

  private executeLoadTemplateSettingsAndPages(template_setting_id: any) {
    const data = this.configureGetTemplateSettingsApiDataParameter(template_setting_id);
    this.getTemplateSettingsFromApiJSON(data).subscribe(
      (result) => {
        this.processGetTemplateSettingsResult(result);
      },
      (error) => {
        this.processGetTemplateSettingsError(error);
      },
      () => {
        if (this.folders.length) {
          this.stopDisplayLoading();
        }
      }
    );
  }

  private executeGetRecordEmails(sf_token: any, instance_url: any, record_type: any) {
    const data = this.configureGetRecordEmailsApiDataParameter(sf_token, instance_url, record_type);
    this.getSalesforceRecordsEmails(data).subscribe((result) => {
      this.loadEmailsAndSetDataServiceWithEmailRecords(result);
    });
  }

  private loadEmailsAndSetDataServiceWithEmailRecords(result: any) {
    try {
      const res: any = JSON.parse(result);
      this.dataService.setRecordEmails(res);
    } catch {}
  }

  private getSalesforceRecordsEmails(data: { sf_token: any; instance_url: any; record_type: any }) {
    return this.dataService.apiPostCall('/api/get_emails', data);
  }

  private configureGetRecordEmailsApiDataParameter(sf_token: any, instance_url: any, record_type: any) {
    return {
      sf_token: sf_token,
      instance_url: instance_url,
      record_type: record_type
    };
  }

  private async processLoadSalesforceDataFromParentFrameAndUpdateUserDB() {
    await this.getSalesforceSessionDataFromBackend();
    if (this.checkIfSessionIsNotValid()) {
      this.invalidSalesforceSessionDisplayLoginAndError();
    } else {
      const { sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url } =
        this.setLocalParametersFromSalesforceSession();
      this.checkUserDataInDbAndProccedLoading(sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url);
    }
  }

  private checkUserDataInDbAndProccedLoading(
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any
  ) {
    this.setupUserDataGobalObject(sf_user_id, sf_org_id, sf_token, sf_refresh, instance_url);
    this.updateLoading(true, "Checking validity of user's token.");
    this.checkIfUserInDbGivenSalesforceUserId(sf_user_id).subscribe((result) => {
      this.ifUserHasValidSNTokenUpdateDBWithData(result);
    });
  }

  private setupUserDataGobalObject(
    sf_user_id: any,
    sf_org_id: any,
    sf_token: any,
    sf_refresh: any,
    instance_url: any
  ) {
    this.user_data = {
      sf_user_id: sf_user_id,
      sn_token: '',
      sn_refresh: '',
      sf_org_id: sf_org_id,
      sf_token: sf_token,
      sf_refresh: sf_refresh,
      instance_url: instance_url
    };
  }

  private ifUserHasValidSNTokenUpdateDBWithData(data: any) {
    if (!(data.in_db == true && data.valid_sn_token == true)) {
      this.forceUsersToLoginBeforeContinuing();
    } else {
      this.setGlobalDataParameters(data);
      this.getDocuments();
      this.updateUserDbIfUserDataSignNowTokenIsntEmpty();
    }
  }

  private async getDocuments() {
    this.setLoadingDisplay('Getting SignNow folders and documents.');
    const documentId = this.dataService.getMergeAttachmentDocId();
    this.folders = [];
    this.folders = await this.addDocumentsToFolder([documentId]);

    // this.folders[0].documents;
    if (this.using_template_settings) {
      if (!this.loading_template_setting) {
        this.stopDisplayLoading();
      }
    } else {
      this.stopDisplayLoading();
    }
  }

  private async addDocumentsToFolder(documentIds: string[]) {
    const folders = documentsModel.folders;
    folders[0].documents = [];
    const current_user_sn_email = this.getCurrentSNEmailFromDataService();
    for (let i = 0; i < documentIds.length; i++) {
      const documentId = documentIds[i];
      const document: any = await this.getDocumentApiPromise(documentId);
      document.is_owner = this.setIsOwnerIfCurrentUserOwnsDocument(
        document.is_owner,
        document.owner,
        current_user_sn_email
      );
      this.loopOverEachFieldInDocAndConfigureDataBindingData(document);
      folders[0].documents.push(document);
    }
    return folders;
  }

  private getDocumentApiPromise(documentId) {
    return this.dataService.apiGetCall('/api/get_document?document_id=' + documentId).toPromise();
  }

  private setGlobalDataParameters(data: any) {
    this.setSNTokenAndRefreshToUserDataGlobalVariable(data);
    this.dataService.setSignNowOwnerEmail(data.sn_email);
  }

  private setSNTokenAndRefreshToUserDataGlobalVariable(data: any) {
    this.user_data.sn_token = data.sn_token;
    this.user_data.sn_refresh = data.sn_refresh;
  }

  private updateUserDbIfUserDataSignNowTokenIsntEmpty() {
    if (this.user_data.sn_token != '') {
      this.userDBApi();
    }
  }

  private loginToSignNow(login_data: { username: any; password: any }) {
    return this.dataService.apiPostCall('/api/login_to_signnow', JSON.stringify(login_data));
  }

  private processLoginToSignNowResult(result: any, email: any) {
    this.updateLoading(true, 'Login with SignNow response returned.');
    if (result.valid_credentials == true) {
      this.validCredentiailsUpdateUserDataSNEmailAndUserDB(result, email);
    } else {
      this.badLoginStopLoadingAndDisplayErrorMessage();
    }
  }

  private badLoginStopLoadingAndDisplayErrorMessage() {
    this.updateLoading(false, '');
    this.updateError('Invalid user credentials. Please enter valid user credentials to log in to SignNow.');
  }

  private validCredentiailsUpdateUserDataSNEmailAndUserDB(loginUserResult: any, email: any) {
    this.userLoggedInClearErrorsSetLoginRequiredToFalse();
    this.configureLoginResultData(loginUserResult, email);
    this.updateLoading(true, 'Validating SignNow login credentials and updating user data on this account.');
    this.updateDBReloadComponent();
  }

  private updateDBReloadComponent() {
    this.updateUserDBGivenUserData().subscribe(() => {
      this.doneUpdatingUserDbReloadComponent();
    });
  }

  private configureLoginResultData(loginUserResult: any, email: any) {
    const sn_token = loginUserResult.sn_token;
    const sn_refresh = loginUserResult.sn_refresh;
    this.setUserDataSNTokenRefreshAndEmail(sn_token, sn_refresh, email);
    this.dataService.setSignNowOwnerEmail(email);
  }

  private setUserDataSNTokenRefreshAndEmail(sn_token: any, sn_refresh: any, email: any) {
    this.user_data.sn_token = sn_token;
    this.user_data.sn_refresh = sn_refresh;
    this.user_data.sn_email = email;
  }

  private userLoggedInClearErrorsSetLoginRequiredToFalse() {
    this.clearErrors();
    this.login = false;
  }

  private doneUpdatingUserDbReloadComponent() {
    this.updateLoading(false, '');
    this.reload();
  }

  private documentPopupWithTemplateSettings(document: any) {
    if (this.isTemplateSettingDocumentNameIsEmptyString()) {
      this.setGlobalSelectedDocumentName(document.document_name);
    } else if (this.isTemplateSettingDocumentNameBlankSpaceString()) {
      this.setGlobalSelectedDocumentName(document.document_name);
    } else if (this.isTemplateSettingDocumentNameNotNullOrUndefined()) {
      this.setGlobalSelectedDocumentName(this.template_setting.document_name);
    } else {
      this.setGlobalSelectedDocumentName(document.document_name);
    }
    this.ifTemplateSettingsSkipSettingsGenerateAndContinue();
  }

  private ifTemplateSettingsSkipSettingsGenerateAndContinue() {
    if (this.template_setting.skip_to_email_invite) {
      this.cloneTemplate(this.selected_document_name);
    }
  }

  private isTemplateSettingDocumentNameNotNullOrUndefined() {
    return this.template_setting.document_name !== undefined || this.template_setting.document_name !== null;
  }

  private isTemplateSettingDocumentNameBlankSpaceString() {
    return this.template_setting.document_name.split(' ').join('') === '';
  }

  private setGlobalSelectedDocumentName(document_name: any) {
    this.selected_document_name = document_name;
  }

  private isTemplateSettingDocumentNameIsEmptyString() {
    return this.template_setting.document_name.length == 0;
  }

  private isUsingTemplateSettings() {
    return this.using_template_settings == true;
  }

  private AssignDocumentToGlobalParameterSelectedDocument(document: any) {
    this.selected_document = document;
  }

  private showDocumentPopupHideGroupPopup() {
    this.setDocumentPopupState(true);
    this.setDocumentGroupState(false);
  }

  private setDocumentPopupState(state: boolean) {
    this.document_popup = state;
  }

  private setDocumentGroupState(state: boolean) {
    this.group_popup = state;
  }

  private async appendSFDataToSNFieldsInDocuments(document_ids: any) {
    let succesfullyAppendSFDataToFieldCount = 0;
    for (let i = 0; i < document_ids.length; i++) {
      const document = await this.getDocumentApi(document_ids[i]).toPromise();
      const success = await this.AppendSFDataToPrefillSNFields(document);
      succesfullyAppendSFDataToFieldCount = this.ifSuccesfullyAppendSFDataToPrefillSNFieldsIncreamentCount(
        success,
        succesfullyAppendSFDataToFieldCount
      );
    }
    return succesfullyAppendSFDataToFieldCount;
  }

  private isSuccessCountEqualsDocumentIdsCount(count: number, document_ids: any) {
    return count == document_ids.length ? true : false;
  }

  private ifSuccesfullyAppendSFDataToPrefillSNFieldsIncreamentCount(success: boolean, count: number) {
    if (success == true) {
      count++;
    }
    return count;
  }

  private getDocumentApi(document_id: any) {
    return this.dataService.apiGetCall('/api/get_document?document_id=' + document_id);
  }

  private getDocumentAnnotationsApi(document_id: any) {
    return this.dataService.apiGetCall('/api/get_document_annotations?document_id=' + document_id);
  }

  private errorOccuredOnAddAnnotationsToDocumentApiCall() {
    this.updateError(
      'An error has occured while processing Salesforce annotations. Please make sure that there are no empty Salesforce field values for the annotations.'
    );
    this.updateLoading(false, '');
  }

  private redirectToNextStep() {
    this.updateLoading(true, 'Annotations successfully added to documents  in the document group.');
    this.router.navigate(['send'], { queryParams: { sending_type: 'merge_attachments' } });
  }

  private addAnnotationsToDocumentApi(
    document_id: any,
    salesforceAnnotationData: {
      sf_token: string;
      instance_url: string;
      record_type: string;
      record_id: string;
      annotations: any;
    }
  ) {
    return this.dataService.apiPostCall(
      '/api/add_annotations_to_document?document_id=' + document_id,
      salesforceAnnotationData
    );
  }

  private isDocumentAnnotationListNotEmpty(documentAnnotation: any) {
    return documentAnnotation.length !== 0;
  }

  private executeAddAnnotationsToDocument(
    data: any,
    salesforceAnnotationData: {
      sf_token: string;
      instance_url: string;
      record_type: string;
      record_id: string;
      annotations: any;
    },
    new_document: any
  ) {
    this.addAnnotationsToDocumentApi(data.document_id, salesforceAnnotationData).subscribe(
      async (result) => {
        await this.processAddAnnotationsToDocumentApiResult(result, new_document);
      },
      () => {
        this.errorOccuredOnAddAnnotationsToDocumentApiCall();
      }
    );
  }

  private async processAddAnnotationsToDocumentApiResult(result: any, new_document: any) {
    result = JSON.parse(result);
    if (result.success == true) {
      await this.addAnnotationsToDocumentApiSuccessResult(new_document);
    } else {
      this.resetDataAndUpdateError(result.error);
    }
    return result;
  }

  private async addAnnotationsToDocumentApiSuccessResult(new_document: any) {
    const success = await this.AppendSFDataToPrefillSNFields(new_document);
    this.ifSuccesfullyAppendedSFDataToPrefillSNFieldsContinue(success);
  }

  private ifSuccesfullyAppendedSFDataToPrefillSNFieldsContinue(success: boolean) {
    if (success == true) {
      this.stopLoadingAndRedirect();
    }
  }

  private stopLoadingAndRedirect() {
    this.loading.hide();
    this.redirectToNextStep();
  }

  private initSalesforceAnnotationDataForApiParameter(data) {
    const salesforce = this.dataService.getSalesforceData();
    const salesforce_annotation_data = {
      sf_token: salesforce.sf_token,
      instance_url: salesforce.instance_url,
      record_type: salesforce.record_type,
      record_id: salesforce.record_id,
      annotations: data.annotations
    };
    return salesforce_annotation_data;
  }

  private displayDocumentPopup(template: any) {
    this.updateLoading(false, '');
    this.documentNamePopup(template);
  }

  private clearErrorsAndSetLoadingMessage(message: string) {
    this.clearErrors();
    this.updateLoading(true, message);
  }

  private processPushbackToTemplateApiResponse(): (value: any) => void {
    return () => {
      this.resetDataAndUpdateError(false, true, true, 'Reloading data.');
    };
  }

  private addPushbackToTemplateApi(documentId: any, fields: any[]) {
    return this.dataService.apiPostCall(
      '/api/add_pushback_to_template',
      JSON.stringify({
        document_id: documentId,
        pushback_fields: fields
      })
    );
  }

  private configurePushBackFields(fields: any[]) {
    for (let i = 0; i < this.selected_pushback_document.fields.length; i++) {
      const currentField = this.selected_pushback_document.fields[i];
      this.setPushbackTypeToDocumentsFieldIntegrationsType(currentField);
      const field: any = this.initFieldForPushback(this.selected_pushback_document, currentField);
      this.setPushbackSettingsPrefillAndUpdate(currentField, this.selected_pushback_document.fields[i]);
      this.ifUpdateAndPrefillSettingIsNoSetFieldValueToBlank(this.selected_pushback_document.fields[i]);
      this.setIntegrationsToUpdateIntegrations(field, this.selected_pushback_document.fields[i]);
      this.addUpdatedFieldToFieldsList(fields, field);
    }
    return fields;
  }

  private setPushbackSettingsPrefillAndUpdate(currentField: any, preSelectedCurrentField) {
    const prefilledValueFromForm = this.setUpdateFieldSetting(currentField, preSelectedCurrentField);
    this.setPrefillFieldSetting(preSelectedCurrentField, prefilledValueFromForm);
  }

  private initFieldForPushback(selectedDocument: any, currentField: any) {
    return this.databindingService.initDefaultFieldForPushback(selectedDocument, currentField);
  }

  private checkPushbackErrors(valid_field_count: number, field_value_counts_update: Map<string, number>) {
    this.checkIfTypeIsBlankError(valid_field_count);
    this.checkIfFieldCountZeroError(valid_field_count);
    this.checkIfDuplicatePushbackFieldsError(field_value_counts_update);
  }

  private addUpdatedFieldToFieldsList(fields: any[], field: any) {
    fields.push(field);
  }

  private setIntegrationsToUpdateIntegrations(field: any, selectedDocumentCurrentField: any) {
    field.integrations.push(selectedDocumentCurrentField.integrations[0]);
  }

  private ifUpdateAndPrefillSettingIsNoSetFieldValueToBlank(selectedDocumentCurrentField: any) {
    if (
      selectedDocumentCurrentField.integrations[0].update === 'no' &&
      selectedDocumentCurrentField.integrations[0].isAppendToSN === 'no'
    ) {
      selectedDocumentCurrentField.integrations[0].field = '';
    }
  }

  private setPrefillFieldSetting(preSelectedCurrentField: any, prefilledValueFromForm: any) {
    preSelectedCurrentField.integrations[0].isAppendToSN =
      prefilledValueFromForm && preSelectedCurrentField.isAppendSfFieldIntoSnField ? 'yes' : 'no';
  }

  private setUpdateFieldSetting(currentField: any, preSelectedCurrentField: any) {
    const prefilledValueFromForm = currentField.integrations[0].field;
    preSelectedCurrentField.integrations[0].update =
      prefilledValueFromForm && preSelectedCurrentField.isUpdateSfFieldFromDocument ? 'yes' : 'no';
    return prefilledValueFromForm;
  }

  private setPushbackTypeToDocumentsFieldIntegrationsType(currentField: any) {
    if (this.isValidFieldType(currentField.type)) {
      currentField.integrations[0].type = this.pushbackType.name;
    }
  }

  private checkIfDuplicatePushbackFieldsError(field_value_counts_update: Map<string, number>) {
    for (const entry of Array.from(field_value_counts_update.entries())) {
      const count = entry[1];
      if (count > 1) {
        this.resetDataAndUpdateError(this.pushBackErrorsMsg.duplicatePushbackField, true);
      }
    }
  }

  private checkIfFieldCountZeroError(valid_field_count: number) {
    if (valid_field_count == 0 && this.pushbackType.name !== '') {
      this.resetDataAndUpdateError(this.pushBackErrorsMsg.cannotAssignPushbackRecord, true);
    }
  }

  private checkIfTypeIsBlankError(valid_field_count: number) {
    if (this.isNotTypeBlankAndFieldCountIsMoreThenZero(valid_field_count)) {
      this.resetDataAndUpdateError(this.pushBackErrorsMsg.cannotAddPushbackToRecord, true);
    }
  }

  private isNotTypeBlankAndFieldCountIsMoreThenZero(valid_field_count: number) {
    return valid_field_count > 0 && this.pushbackType.name.split(' ').join('') === '';
  }

  private initAddDataBindingVariables() {
    const fields = [];
    const field_value_counts = new Map<string, number>();
    const field_value_counts_update = new Map<string, number>();
    return { field_value_counts, field_value_counts_update, fields };
  }

  private resetDatabindingErrors() {
    this.removeErrorMessage(this.pushBackErrorsMsg.cannotAddPushbackToRecord);
    this.removeErrorMessage(this.pushBackErrorsMsg.cannotAssignPushbackRecord);
    this.removeErrorMessage(this.pushBackErrorsMsg.duplicatePushbackField);
  }

  private processFieldsValuesForDatabinding(
    field_value_counts: Map<string, number>,
    field_value_counts_update: Map<string, number>,
    document: any
  ) {
    let valid_field_count = 0;
    let valid_field_update_count = 0;
    for (let i = 0; i < document.fields.length; i++) {
      const value = document.fields[i].integrations[0].field;
      const type = document.fields[i].type;
      const isUpdateSfFieldFromDocument = document.fields[i].isUpdateSfFieldFromDocument;
      if (this.valueIsNotEmptyAndValidType(value, type)) {
        valid_field_count++;
        this.setFeildValueCount(field_value_counts, value);
        if (isUpdateSfFieldFromDocument === true) {
          valid_field_update_count++;
          this.setUpdatedFieldValueCount(field_value_counts_update, value);
        }
      }
    }
    return { valid_field_count, valid_field_update_count, document };
  }

  private setUpdatedFieldValueCount(field_value_counts_update: Map<string, number>, value: any) {
    const update_count: number = this.getUpdatedCountFromFieldValueCounts(field_value_counts_update, value);
    field_value_counts_update.set(value, update_count);
  }

  private setFeildValueCount(field_value_counts: Map<string, number>, value: any) {
    let count: number = this.getCountFromFieldValueCounts(field_value_counts, value);
    count++;
    field_value_counts.set(value, count);
  }

  private getUpdatedCountFromFieldValueCounts(
    field_value_counts_update: Map<string, number>,
    value: any
  ): number {
    return field_value_counts_update.get(value) == undefined ? 1 : field_value_counts_update.get(value) + 1;
  }

  private getCountFromFieldValueCounts(field_value_counts: Map<string, number>, value: any): number {
    return field_value_counts.get(value) == undefined ? 0 : field_value_counts.get(value);
  }

  private valueIsNotEmptyAndValidType(value: any, type: any) {
    return value !== '' && this.isValidFieldType(type);
  }

  private isValidFieldType(type: any) {
    return type === 'text' || type === 'checkbox' || type === 'radiobutton' || type === 'enumeration';
  }

  private ResetDuplicatePushbackTypeErrorMessages() {
    this.removeErrorMessage(this.pushBackErrorsMsg.duplicatePushbackTypes);
  }

  private loopOverFieldsInDocumentAndSetupDatabinding(document: any, dataBindingTypes: Set<string>) {
    for (let i = 0; i < document.fields.length; i++) {
      this.ifFieldJSOAttribNameIsInvalidSetToEmptyString(document.fields[i]);
      this.ifFieldJSOAttribLabelIsInvalidSetToEmptyString(document.fields[i]);
      let integrations = this.ifFieldJSONAttriIntegrationsIsInvalidSetDefault(document.fields[i]);
      integrations = this.ifFieldJSONAttriIntegrationsIsValidSetupIntegrationData(
        document.fields[i],
        integrations,
        document,
        i,
        dataBindingTypes
      );
      this.updateCurrentFieldIntegrations(document.fields[i], integrations);
    }
  }

  private ifFieldJSOAttribNameIsInvalidSetToEmptyString(field: any) {
    if (field.json_attributes.name == null || field.json_attributes.name == undefined) {
      field.json_attributes.name = '';
    }
  }

  private ifFieldJSOAttribLabelIsInvalidSetToEmptyString(field: any) {
    if (field.json_attributes.label == null || field.json_attributes.label == undefined) {
      field.json_attributes.label = '';
    }
  }

  private ifFieldJSONAttriIntegrationsIsValidSetupIntegrationData(
    field: any,
    integrations: any,
    document: any,
    i: number,
    dataBindingTypes: Set<string>
  ) {
    if (!this.isFieldIntegrationPropertyInvalid(field)) {
      integrations = this.fieldJSONAttriIntegrationValid(integrations, field);
      this.ifValidIntegTypeAndFieldTypeAddIntegTypeToDataBinding(integrations, document, i, dataBindingTypes);
    }
    return integrations;
  }

  private ifFieldJSONAttriIntegrationsIsInvalidSetDefault(field: any) {
    let integrations;
    if (this.isFieldIntegrationPropertyInvalid(field)) {
      integrations = [
        {
          type: '',
          field: '',
          update: 'no',
          isAppendToSN: 'no',
          integration_id: '98e94c607b2be81b9ddec0a8a2388066141b8027'
        }
      ];
    }
    return integrations;
  }

  private isFieldIntegrationPropertyInvalid(field: any) {
    return field.json_attributes.integrations == undefined || field.json_attributes.integrations == null;
  }

  private fieldJSONAttriIntegrationValid(integrations: any, field: any) {
    integrations = field.json_attributes.integrations;
    return integrations;
  }

  private ifValidIntegTypeAndFieldTypeAddIntegTypeToDataBinding(
    integrations: any,
    document: any,
    i: number,
    dataBindingTypes: Set<string>
  ) {
    if (integrations[0].type != '' && this.isValidFieldType(document.fields[i].type)) {
      dataBindingTypes.add(integrations[0].type);
    }
  }

  private ConvertDataBindingTypesToArray(dataBindingTypes: Set<string>) {
    return Array.from(dataBindingTypes);
  }

  private ifDatabindingTypesArrayLengthIsntEmptyErrorDuplicateTypes(dataBindingTypesArray: string[]) {
    if (dataBindingTypesArray.length > 1) {
      this.resetDataAndUpdateError(this.pushBackErrorsMsg.duplicatePushbackTypes, true);
    }
  }

  private ifDataBindingTypesArrayLengthIsOneSetPushbackType(dataBindingTypesArray: string[]) {
    if (dataBindingTypesArray.length === 1) {
      this.ifDataBindingTypesIsValidSetToPushbackTypeOrEmpty(dataBindingTypesArray);
    }
  }

  private ifDataBindingTypesIsValidSetToPushbackTypeOrEmpty(dataBindingTypesArray: string[]) {
    this.pushbackType.name = dataBindingTypesArray[0] != undefined ? dataBindingTypesArray[0] : '';
  }

  private updateCurrentFieldIntegrations(field: any, integrations: any) {
    field.integrations = integrations;
  }

  private async processAppendSFDataToPrefillSNFields(new_document: any, fields: any[]) {
    let result;
    try {
      result = await this.getRecordByIdAndProcessDatabinding(new_document, fields);
    } catch (error) {
      result = this.errorOccuredOnAppendSFDataToPrefillSNFields(error);
    }
    return result;
  }

  private async getRecordByIdAndProcessDatabinding(new_document: any, fields: any[]) {
    const params = this.initGetRecordByIdApiParameter();
    const record = await this.getSFRecordById(params).toPromise();
    let result;
    if (record) {
      result = this.validRecordProcessDataBindingAndAddToSNDocument(new_document, record, fields);
    } else if (record && record.errorCode) {
      throw Error('Append SF Data To Prefill SN Fields Failed.');
    }
    return result;
  }

  private errorOccuredOnAppendSFDataToPrefillSNFields(error: any) {
    this.updateLoading(false, '');
    this.updateError(error);
    return false;
  }

  private async validRecordProcessDataBindingAndAddToSNDocument(
    new_document: any,
    record: any,
    fields: any[]
  ) {
    for (let i = 0; i < new_document.fields.length; i++) {
      this.ifValidFieldTypeSetPushbackTypeToIntegrationType(new_document.fields[i]);
      const prefilledValueFromForm = this.setPrefillValueFromForm(new_document.fields[i]);
      const previousPrefilledValue = this.setPreviousPrefillValue(new_document.fields[i]);
      const prefilledValueFromRecord = this.assignPrefillValueFromRecordToPrefillOrPrev(
        record,
        prefilledValueFromForm,
        previousPrefilledValue
      );
      const field: any = this.initDefaultFieldForDatabinding(
        new_document.fields[i],
        prefilledValueFromRecord,
        previousPrefilledValue
      );
      this.ifRadioButtonUpdateFieldSettingForDatabinding(new_document.fields[i], field);
      this.ifEnumerationUpdateFieldSettingForDatabinding(new_document.fields[i], field, new_document);
      this.setIntegrationFromDocumentFieldToFieldVariable(field, new_document.fields[i]);
      this.addFieldToFieldsList(fields, field);
    }
    this.setDatabindingInfoForAnalytics(fields); // only when updating the document that will be sent to Send Page
    return await this.addPushbackToTemplate(new_document, fields);
  }

  private async addPushbackToTemplate(new_document: any, fields: any[]) {
    try {
      await this.addPushbackToTemplateApi(new_document.id, fields).toPromise();
      return true;
    } catch {
      return false;
    }
  }

  private addFieldToFieldsList(fields: any[], field: any) {
    fields.push(field);
  }

  private setIntegrationFromDocumentFieldToFieldVariable(field: any, docField: any) {
    field.integrations.push(docField.integrations[0]);
  }

  private ifEnumerationUpdateFieldSettingForDatabinding(docField: any, field: any, new_document: any) {
    if (docField.type === 'enumeration') {
      field.enumeration_options = [];
      for (let idx = 0; idx < new_document.enumeration_options.length; idx++) {
        if (new_document.enumeration_options[idx].enumeration_id === docField.id) {
          field.enumeration_options.push(new_document.enumeration_options[idx].data);
        }
      }
    }
  }

  private ifRadioButtonUpdateFieldSettingForDatabinding(docField: any, field: any) {
    if (docField.type === 'radiobutton') {
      field.radio = docField.radio;
      field.name = docField.json_attributes.name;
    }
  }

  private initDefaultFieldForDatabinding(
    docField: any,
    prefilledValueFromRecord: any,
    previousPrefilledValue: any
  ): any {
    const field: any = {
      label: docField.json_attributes.label,
      prefilled_text:
        docField.integrations[0].isAppendToSN === 'yes' ? prefilledValueFromRecord : previousPrefilledValue,
      x: docField.json_attributes.x,
      y: docField.json_attributes.y,
      width: docField.json_attributes.width,
      height: docField.json_attributes.height,
      page_number: docField.json_attributes.page_number,
      role: docField.role,
      lock_to_sign_date: docField.json_attributes.lock_to_sign_date,
      arrangement: docField.json_attributes.arrangement,
      font: docField.json_attributes.font,
      max_chars: docField.json_attributes.max_chars,
      max_lines: docField.json_attributes.max_lines,
      valign: docField.json_attributes.valign,
      required: docField.json_attributes.required,
      type: docField.type,
      integrations: []
    };

    if (docField.json_attributes.validator_id) {
      field.validator_id = docField.json_attributes.validator_id;
    }

    return field;
  }

  private assignPrefillValueFromRecordToPrefillOrPrev(
    record: any,
    prefilledValueFromForm: any,
    previousPrefilledValue: any
  ) {
    return record[prefilledValueFromForm] || previousPrefilledValue;
  }

  private setPreviousPrefillValue(docField: any) {
    return docField.json_attributes.prefilled_text;
  }

  private setPrefillValueFromForm(docField: any) {
    return docField.integrations[0].field;
  }

  private ifValidFieldTypeSetPushbackTypeToIntegrationType(docfield: any) {
    if (this.isValidFieldType(docfield.type)) {
      docfield.integrations[0].type = this.pushbackType.name;
    }
  }

  private getSFRecordById(params: {
    sf_token: string;
    instance_url: string;
    sf_obg_type: string;
    sf_obg_id: string;
  }) {
    return this.dataService.apiGetCall('/api/get_record_by_id', { params });
  }

  private initGetRecordByIdApiParameter() {
    const salesforce_data = this.dataService.getSalesforceData();
    const params = {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      sf_obg_type: this.pushbackType.name,
      sf_obg_id: salesforce_data.record_id
    };
    return params;
  }

  private executBasedOnSelectedOption(
    selectedOption: any,
    document: any,
    countNumAppropriateFieldsInDoc: number
  ) {
    this.ifSelectedOptionEditOpenSNDocument(selectedOption, document);
    this.ifSelectedOptionAnnotationOpenSNAnnotation(selectedOption, document);
    this.ifSelectedOptionPushbackDisplayPushBackModal(
      selectedOption,
      document,
      countNumAppropriateFieldsInDoc
    );
  }

  private ifSelectedOptionPushbackDisplayPushBackModal(
    selectedOption: any,
    document: any,
    countNumAppropriateFieldsInDoc: number
  ) {
    if (selectedOption.value == 'pushback') {
      this.showPushbackPopup();
      countNumAppropriateFieldsInDoc = this.loopThroughDocumentFieldsAndConfigurePushback(
        document,
        countNumAppropriateFieldsInDoc
      );
      this.hideOrShowPushbackPopupBasedOnApproprietFieldsInDocCount(countNumAppropriateFieldsInDoc);
      this.setPushbackTypeFromDocOrEmptyIfNoTypeInDoc(document);
      this.setSelectedDocumentToCurrentDocument(document);
      this.resetOptionDropDownIndex(selectedOption);
      this.setIsOwnerOfSelectedPushbackDocToIsUserOwnerOfSelectedDoc();
      // this.getSfObjectMeta(this.pushbackType.name);
    }
  }

  private hideOrShowPushbackPopupBasedOnApproprietFieldsInDocCount(countNumAppropriateFieldsInDoc: number) {
    this.ifCountAppropriateFieldsInDocIsZeroHidePushbackPopup(countNumAppropriateFieldsInDoc);
    this.ifCountAppropriateFieldsInDocIsNotZeroShowPushbackPopup(countNumAppropriateFieldsInDoc);
  }

  private setIsOwnerOfSelectedPushbackDocToIsUserOwnerOfSelectedDoc() {
    this.is_user_owner_of_selected_document = this.selected_pushback_document.is_owner;
  }

  private resetOptionDropDownIndex(selectedOption: any) {
    selectedOption.selectedIndex = 0;
  }

  private setSelectedDocumentToCurrentDocument(document: any) {
    this.selected_pushback_document = document;
  }

  private setPushbackTypeFromDocOrEmptyIfNoTypeInDoc(document: any) {
    this.pushbackType.name = document.fields.length ? document.fields[0].integrations[0].type : '';
  }

  private ifCountAppropriateFieldsInDocIsNotZeroShowPushbackPopup(countNumAppropriateFieldsInDoc: number) {
    if (countNumAppropriateFieldsInDoc !== 0) {
      this.showPushbackPopup();
    }
  }

  private ifCountAppropriateFieldsInDocIsZeroHidePushbackPopup(countNumAppropriateFieldsInDoc: number) {
    if (countNumAppropriateFieldsInDoc === 0) {
      this.hidePushbackPopup();
    }
  }

  private hidePushbackPopup() {
    this.setPushBackPopupState(false);
  }

  private loopThroughDocumentFieldsAndConfigurePushback(
    document: any,
    countNumAppropriateFieldsInDoc: number
  ) {
    for (let i = 0; i < document.fields.length; i++) {
      countNumAppropriateFieldsInDoc = this.ifValidFieldTypeIncreamentCountOfAppropriateFields(
        document.fields[i].type,
        countNumAppropriateFieldsInDoc
      );
      document.fields[i].json_attributes.name = this.ifJSONAttribNameIsInvalidSetToBlank(
        document.fields[i].json_attributes.name
      );
      document.fields[i].json_attributes.label = this.ifJSONAttribLabelIsInvalidSetToBlank(
        document.fields[i].json_attributes.label
      );
      let integrations = this.ifFieldJSONAttriIntegrationsIsInvalidSetDefault(document.fields[i]);
      integrations = this.ifFieldJSONAttriIntegrationsIsValidSetTheIntegrationData(
        document.fields[i],
        integrations
      );
      this.updateCurrentFieldIntegrations(document.fields[i], integrations);
    }
    return countNumAppropriateFieldsInDoc;
  }

  private ifFieldJSONAttriIntegrationsIsValidSetTheIntegrationData(docField: any, integrations: any) {
    if (!this.isFieldIntegrationPropertyInvalid(docField)) {
      integrations = docField.json_attributes.integrations;
    }
    return integrations;
  }

  private ifJSONAttribLabelIsInvalidSetToBlank(label: any) {
    if (label == null || label == undefined) {
      label = '';
    }
    return label;
  }

  private ifJSONAttribNameIsInvalidSetToBlank(name: any) {
    if (name == null || name == undefined) {
      name = '';
    }
    return name;
  }

  private ifValidFieldTypeIncreamentCountOfAppropriateFields(
    type: any,
    countNumAppropriateFieldsInDoc: number
  ) {
    if (this.isValidFieldType(type)) {
      countNumAppropriateFieldsInDoc++;
    }
    return countNumAppropriateFieldsInDoc;
  }

  private showPushbackPopup() {
    this.setPushBackPopupState(true);
  }

  private setPushBackPopupState(state: boolean) {
    this.is_show_pushback_popup = state;
  }

  private ifSelectedOptionAnnotationOpenSNAnnotation(selectedOption: any, document: any) {
    if (selectedOption.value === 'annotations') {
      const url = `${APP_BASE_LINK}/webapp/annotations/${document.id}?annotation_types=salesforce`;
      window.open(url, '_blank');
      selectedOption.selectedIndex = 0;
    }
  }

  private ifSelectedOptionEditOpenSNDocument(selectedOption: any, document: any) {
    if (selectedOption.value === 'edit') {
      const redirect_url = window.location.origin + '/close_popup';
      this.edit_document = true;
      const sn_token = this.user_data.sn_token;
      const url = `${APP_BASE_LINK}/webapp/document/${document.id}?access_token=${sn_token}&redirect_uri=`;
      this.edit_document_url = this.sanitizer.bypassSecurityTrustResourceUrl(
        url + encodeURIComponent(redirect_url)
      );
      selectedOption.selectedIndex = 0;
    }
  }

  private setRefreshState(state: boolean) {
    this.refresh = state;
  }

  private ifRefreshRequiredIsTrueAndSelectedOptionIsPushbackErrorReload(selected_option: any) {
    if (this.refresh == true && selected_option.value == 'pushback') {
      selected_option.selectedIndex = 0;
      this.updateError('Please click Reload before setting Data Binding for the document.');
    }
  }

  private ifPushBackTypeIsValidErrorContinue(
    pushback_type: string,
    type: string,
    document: any,
    new_name: any
  ) {
    if (pushback_type === '' || pushback_type === type) {
      this.getDocumentApi(document.id).subscribe((document) => {
        this.ifRolesLengthIsEmptyThenError(
          document.roles,
          `Document doesn't have any Roles and Fields. Please add Roles and Fields to the Document before sending it out for signing.`
        );
        this.ifDocumentContainsRolesConinue(document, new_name);
      });
    }
  }

  private ifDocumentContainsRolesConinue(document: any, new_name: any) {
    if (document.roles.length > 0) {
      this.generateDocumentFromTemplateApi(document, new_name).subscribe(
        async (result) => {
          const documentId = result.id;
          document = await this.getDocumentApi(documentId).toPromise();
          this.setLoadingDisplay('New document successfully generated. Making call to get document data.');

          this.setNewDocumentIdFromResultOnDataService(documentId);
          this.getDocumentAnnotationsApi(documentId).subscribe(() => {
            this.ifRolesLengthIsEmptyThenError(
              document.roles,
              `Document doesn't have any Roles and Fields. Please add Roles and Fields to the Document before sending it out for signing.`
            );
            this.ifEmptyRoutingButDocumentHasRolesConfigureRouting(document);
            this.ifRoutingIsValidAndNoEmptyRoles(document, result);
          });
        },
        (error) => {
          this.errorOccuredWhileGeneratingDocument(error);
        }
      );
    }
  }

  private errorOccuredWhileGeneratingDocument(error: any) {
    this.errorOccured(error);
  }

  private ifRoutingIsValidAndNoEmptyRoles(document: any, result: any) {
    if (document.roles.length != 0 && document.routing_details.length != 0) {
      this.getDocumentApi(result.id).subscribe((document) => {
        this.configureNewDocumentData(document);
      });
    }
  }

  private configureNewDocumentData(document: any) {
    this.setGlobalNewDocVariable(document);
    this.setLoadingDisplay('Document data received.');
    this.addAnnotationsToDocument(this.new_document);
  }

  private setGlobalNewDocVariable(document: any) {
    this.new_document = document;
  }

  private ifEmptyRoutingButDocumentHasRolesConfigureRouting(document: any) {
    if (document.routing_details.length == 0 && document.roles.length > 0) {
      const routing = this.databindingService.createRoutingDetailsObject(document);

      this.setLoadingDisplay('Updating document with Routing Details.');
      this.updateDocumentRoutingApi(document.id, routing).subscribe((result) => {
        this.getNewDocumentGivenDocumentID(result.document_id);
      });
    }
  }

  private getNewDocumentGivenDocumentID(documentId: any) {
    this.getDocumentApi(documentId).subscribe((document) => {
      this.configureNewDocumentData(document);
    });
  }

  private updateDocumentRoutingApi(documentId: any, routing: { template_data: any[] }) {
    return this.dataService.apiPostCall('/api/update_document_routing?document_id=' + documentId, routing);
  }

  private setNewDocumentIdFromResultOnDataService(documentId: any) {
    this.dataService.setDocumentId(documentId);
  }

  private generateDocumentFromTemplateApi(document: any, new_name: any) {
    return this.dataService.apiGetCall(
      '/api/generate_document_from_template?template_id=' + document.id + '&new_name=' + new_name
    );
  }

  private ifRolesLengthIsEmptyThenError(roles: any, errMsg: string) {
    if (roles.length === 0) {
      this.resetDataAndUpdateError(errMsg);
    }
  }

  private ifPushBackTypeIsNotValidError(pushback_type: string, type: string, document: any) {
    if (pushback_type && pushback_type !== type) {
      const errMsg = `For the template "${document.document_name}" Data Binding record type is set to "${pushback_type}". Go to Data Binding settings and choose "${type}" record type to send out this template.`;
      this.resetDataAndUpdateError(errMsg);
    }
  }

  private setPushBackTypeFromDocumentIntegrationObject(document: any) {
    let pushback_type = '';
    try {
      if (
        document.fields[0].json_attributes.integrations[0].type != null ||
        document.fields[0].json_attributes.integrations[0].type != undefined ||
        document.fields[0].json_attributes.integrations[0].type != ''
      ) {
        pushback_type = document.fields[0].json_attributes.integrations[0].type;
      }
    } catch {}

    return pushback_type;
  }

  private getTypeFromDataService() {
    var type: any = this.dataService.getSalesforceRecordType();

    return type;
  }

  private getDocumentFromGlobalSelectedDocument(): any {
    return this.selected_document;
  }

  private ifDocumentNameIsBlankHidePopupsErrorAndResetData(new_name: any) {
    if (new_name.split(' ').join('') == '') {
      this.resetDataAndUpdateError("Document name can't be empty.");
      this.group_popup = false;
      this.document_popup = false;
    }
  }

  private SetDataServiceParametersBeforeCloningTemplate(new_name: any) {
    this.dataService.setDocumentName(new_name);
    this.dataService.getSalesforceAnnotationsFromDocument(this.selected_document.id);
    this.dataService.setOriginTemplateId(this.selected_document.id);
    this.dataService.setDocumentOwner(this.selected_document.owner);
  }

  private HideDocumentPopup() {
    this.setDocumentPopupState(false);
  }

  private setLoadingDisplay(msg: string) {
    this.updateLoading(true, msg);
  }

  private executeGenerateDocumentFromTemplate(document: any) {
    this.generateDocumentFromTemplateApiNoNewName(document.id).subscribe(
      (result) => {
        this.navigateToPreviewStep(result);
      },
      (error) => {
        this.errorOccuredWhileGeneratingDocFromTemplateApiNoNewName(error);
      }
    );
  }

  private errorOccuredWhileGeneratingDocFromTemplateApiNoNewName(error: any) {
    this.errorOccured(error);
  }

  private errorOccured(error: any) {
    this.errorUpdateWithErrorBody(error);
    this.updateLoading(false, '');
  }

  private errorUpdateWithErrorBody(error: any) {
    this.updateError(error.error);
  }

  private navigateToPreviewStep(result: any) {
    this.router.navigate(['/preview', result.id], { queryParams: { sending_type: 'merge_attachments' } });
  }

  private generateDocumentFromTemplateApiNoNewName(documentId: any) {
    return this.dataService.apiGetCall('/api/generate_document_from_template?template_id=' + documentId);
  }

  private templateInFolderApi(folder_id: string) {
    return this.dataService.apiGetCall('/api/templates_in_folder?folder_id=' + folder_id);
  }

  private getFoldersAndDocuments(folders: any, count: number, current_user_sn_email: any) {
    this.getFoldersApi().subscribe(
      async (result) => {
        await this.LoopOverFoldersGetDocumentsAndDisplayTemplates(
          result,
          folders,
          count,
          current_user_sn_email
        );
        this.stopDisplayLoading();
      },
      (error) => {
        this.errorOccuredWhileGettingFoldersFromApi(error);
      }
    );
  }

  private setGlobalSelectedTemplateFromUrl() {
    return this.dataService.getUrlParamater('template_id');
  }

  private getCurrentSNEmailFromDataService() {
    return this.dataService.getSignNowOwnerEmail();
  }

  private ifTemplateSettingIsValidDisplayDocumentPopup(selected_template_id: string) {
    if (selected_template_id != '' && selected_template_id.length > 0) {
      this.preselectedTemplate(selected_template_id);
    }
  }

  private getFoldersApi() {
    return this.dataService.apiGetCall('/api/folders');
  }

  private async LoopOverFoldersGetDocumentsAndDisplayTemplates(
    result: any,
    folders: any,
    count: number,
    current_user_sn_email: any
  ) {
    for (let i = 0; i < result.folders.length; i++) {
      await this.ifFolderNameIsMatchesTemplatesGetDocuments(
        result.folders[i],
        folders,
        count,
        current_user_sn_email,
        result
      );
    }
  }

  private async ifFolderNameIsMatchesTemplatesGetDocuments(
    folder: any,
    folders: any,
    count: number,
    current_user_sn_email: any,
    result: any
  ) {
    if (this.dataService.isAllowedFolder(folder.name)) {
      folder = await new Promise((resolve) => {
        this.getDocumentsFromFolder(folder.id, function (folder) {
          resolve(folder);
        });
      });
      ({ folders, count } = this.processGetDocumentFromFolder(
        folder,
        current_user_sn_email,
        folders,
        count,
        result
      ));
    }
    return folder;
  }

  private processGetDocumentFromFolder(folder, current_user_sn_email, folders, count, result) {
    this.ifFolderIsTeamTemplatesAppendSharedString(folder);
    this.loopOverDocumentsInFolderAndConfigureList(folder, current_user_sn_email);
    count = this.addCurrentFolderToFoldersList(folders, folder, count);
    this.ifCountEqualsNumberOfFoldersStopLoading(result, count);
    return { folders, count };
  }

  private loopOverDocumentsInFolderAndConfigureList(folder: any, current_user_sn_email: any) {
    folder.documents.forEach((docItem) => {
      docItem.is_owner = this.setIsOwnerIfCurrentUserOwnsDocument(
        docItem.is_owner,
        docItem.owner,
        current_user_sn_email
      );
      this.loopOverEachFieldInDocAndConfigureDataBindingData(docItem);
    });
  }

  private setIsOwnerIfCurrentUserOwnsDocument(is_owner: any, owner: any, current_user_sn_email: any) {
    is_owner = true;
    if (owner !== current_user_sn_email) {
      is_owner = false;
    }
    return is_owner;
  }

  private ifCountEqualsNumberOfFoldersStopLoading(result: any, count: any) {
    if (result.folders.length === count) {
      this.stopDisplayLoading();
    }
  }

  private addCurrentFolderToFoldersList(folders: any, folder: any, count: any) {
    folders.push(folder);
    count++;
    return count;
  }

  private loopOverEachFieldInDocAndConfigureDataBindingData(docItem: any) {
    docItem.fields.forEach(this.configureDataBindingDataForField);
  }

  private configureDataBindingDataForField(fieldItem) {
    const jsonAttr = fieldItem.json_attributes;
    if (jsonAttr.integrations && jsonAttr.integrations.length) {
      fieldItem.isUpdateSfFieldFromDocument = jsonAttr.integrations[0]['update']
        ? jsonAttr.integrations[0]['update'] === 'yes'
        : false;
      fieldItem.isAppendSfFieldIntoSnField = jsonAttr.integrations[0]['isAppendToSN']
        ? jsonAttr.integrations[0]['isAppendToSN'] === 'yes'
        : false;
    }
  }

  private ifFolderIsTeamTemplatesAppendSharedString(folder: any) {
    if (folder.name === 'Team Templates') {
      folder.name = folder.team_name + ' (Shared)';
    }
  }

  reloadAfterSSOLogin() {
    this.login = false;
    this.reload();
  }
}
